import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=f487428e&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=f487428e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f487428e",
  null
  
)

export default component.exports